module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('g-signin-button', {
    attrs: {
      "params": _vm.googleSignInParams
    },
    on: {
      "success": _vm.onSignInSuccess,
      "error": _vm.onSignInError
    }
  }, [_vm._v("\n    Sign in with Google\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b7cd889","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 298
// module chunks = 1